import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerText from '../../../components/custom_components/Text'
import { AppraisalContextType } from '../AppraisalTypes'

type Props = {
  type?: AppraisalContextType
}

export const EvaluationScaleInformation: FC<Props> = ({ type }) => {
  const [t] = useTranslation()
  return (
    <>
      <PerText appearance="sidenote" color="white">
        {t('appraisalMeeting.evaluation.grid.scaleInformation.firstScale')}
      </PerText>
      <PerText appearance="sidenote" color="white">
        {t('appraisalMeeting.evaluation.grid.scaleInformation.secondScale')}
      </PerText>
      <PerText appearance="sidenote" color="white">
        {t('appraisalMeeting.evaluation.grid.scaleInformation.thirdScale')}
      </PerText>

      {type && (
        <PerText appearance="sidenote" mt="s" color="white">
          {t(`appraisalMeeting.evaluation.grid.scaleInformation.${type}AdditionalInfo`)}
        </PerText>
      )}
    </>
  )
}
